import { NgModule } from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {FormsModule} from "@angular/forms";
import {BlockUIModule} from "ng-block-ui";
import {WeaveLoaderComponent} from "../../../shared/loaders/weave-loader/weave-loader.component";
import {HeaderComponent} from "./header.component";
import {AccountMenuComponent} from "./account-menu/account-menu.component";
import {CreateNewComponent} from "./create-new/create-new.component";
import {HelpComponent} from "./help/help.component";
import {ImpersonateComponent} from "./impersonate/impersonate.component";
import {ProgramProfileComponent} from "./account-menu/program-profile/program-profile.component";
import {AccreditationProfileComponent} from "./account-menu/accreditation-profile/accreditation-profile.component";
import {UserRolesComponent} from "./account-menu/user-roles/user-roles.component";
import {HeaderResponsiveComponent} from "../header-responsive/header-responsive.component";
import {BurgerMenuComponent} from "../header-responsive/burger-menu/burger-menu.component";
import {RightMenuComponent} from "../header-responsive/right-menu/right-menu.component";
import {AccountsListComponent} from "../header-responsive/accounts-list/accounts-list.component";
import {TeamManagementComponent} from "../header-responsive/team-management/team-management.component";
import {NotificationsComponent} from "./notifications/notifications.component";
import {NavigationMenuComponent} from "./navigation-menu/navigation-menu.component";
import {RouterLink, RouterLinkActive} from "@angular/router";
import {SharedModule} from "../shared.module";
import {NgScrollbar} from "ngx-scrollbar";
import {MatIcon, MatIconModule
} from "@angular/material/icon";
import {MatIconButton, MatMiniFabButton} from "@angular/material/button";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import { MatError, MatInput, MatLabel } from "@angular/material/input";
import {MatCheckbox} from "@angular/material/checkbox";
import {MatFormField} from "@angular/material/form-field";
import {
  MatExpansionPanel,
  MatExpansionPanelContent,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from "@angular/material/expansion";
import {MatTooltip} from "@angular/material/tooltip";
import {
  NotificationsResponsiveComponent
} from "../header-responsive/notifications-responsive/notifications-responsive.component";
import { HeaderAccountInfoComponent } from "../header-responsive/header-account-info/header-account-info.component";
import {MatSlideToggle} from "@angular/material/slide-toggle";
import {WeaveFormsModule} from "../../../shared/forms/weave-forms.module";
import {
    EditTeamMemberComponent
} from "../header-responsive/team-management/edit-team-member/edit-team-member.component";
import {
    MemberAssignmentToStandardsComponent
} from "../header-responsive/team-management/member-assignment-to-standards/member-assignment-to-standards.component";
import {CdkTextareaAutosize} from "@angular/cdk/text-field";
import { AddTeamMemberComponent } from "../header-responsive/team-management/add-team-member/add-team-member.component";


@NgModule({
  imports: [
    BlockUIModule.forRoot({
      template: WeaveLoaderComponent,
    }),
    CommonModule,
    FormsModule,
    RouterLink,
    NgOptimizedImage,
    RouterLinkActive,
    MatIcon,
    MatIconModule,
    SharedModule,
    NgScrollbar,
    MatIconButton,
    MatMenu,
    MatMenuTrigger,
    MatMenuItem,
    MatMiniFabButton,
    MatFormField,
    MatInput,
    MatLabel,
    MatCheckbox,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatExpansionPanelContent,
    MatTooltip,
    MatError,
    HeaderAccountInfoComponent,
    MatSlideToggle,
    WeaveFormsModule,
    EditTeamMemberComponent,
    MemberAssignmentToStandardsComponent,
    CdkTextareaAutosize,
    AddTeamMemberComponent,
  ],
  declarations: [
    HeaderComponent,
    AccountMenuComponent,
    CreateNewComponent,
    ImpersonateComponent,
    HelpComponent,
    AccreditationProfileComponent,
    ProgramProfileComponent,
    UserRolesComponent,
    HeaderResponsiveComponent,
    BurgerMenuComponent,
    RightMenuComponent,
    AccountsListComponent,
    TeamManagementComponent,
    NotificationsComponent,
    NotificationsResponsiveComponent,
    NavigationMenuComponent,
  ],
  exports: [
    HeaderComponent,
    AccountMenuComponent,
    CreateNewComponent,
    HelpComponent,
    ImpersonateComponent,
    AccreditationProfileComponent,
    ProgramProfileComponent,
    UserRolesComponent,
    HeaderResponsiveComponent,
    BurgerMenuComponent,
    RightMenuComponent,
    AccountsListComponent,
    TeamManagementComponent,
    NotificationsComponent,
    NotificationsResponsiveComponent,
    NavigationMenuComponent,
  ]
})
export class HeaderModule { }
